import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface RollTextProps {
    children: string
    className?: string
}

// Hover label that rolls upwards to reveal a copy of itself. The parent needs
// the `group` class so the roll follows the whole link, not just the text.
const RollText: FC<RollTextProps> = ({ children, className }): ReactNode => {
    return (
        <span className={cn('relative inline-flex overflow-hidden', className)}>
            <span className='block transition-transform duration-500 ease-quart group-hover:-translate-y-full motion-reduce:transition-none'>
                {children}
            </span>

            <span
                aria-hidden='true'
                className='absolute inset-0 block translate-y-full transition-transform duration-500 ease-quart group-hover:translate-y-0 motion-reduce:transition-none'
            >
                {children}
            </span>
        </span>
    )
}

export default RollText
